import { ChevronLeft, ChevronRight, Ellipsis } from 'lucide-react';
import { InputGroup, DefaultTooltip, InputGroupText } from 'twyne-new.ui'

const propTypes = {};

export default function InputTip({ children: input, tip, icon, tipProps = {} }) {
  return <InputGroup>
    {input}
    <DefaultTooltip content={tip} {...tipProps}>
      <InputGroupText addonType='append' className='twy-text-accent-2'>
        {icon ? icon : <>
          <ChevronLeft size={12} />
          <Ellipsis size={12} />
          <ChevronRight size={12} />
        </>}
      </InputGroupText>
    </DefaultTooltip>
  </InputGroup>
}

InputTip.propTypes = propTypes
InputTip.defaultProps = {}
